// packages import
import { useContext } from "react";
import { ContentHead } from "../../../components/common/ContentHead";
import { CourtsContainer } from "../../../containers/CourtsContainer";
import { CardBox } from "../../../theme/styleComponents";
import { AuthContext } from "../../../context";

export const Courts = (): JSX.Element => {
  const { isAdmin } = useContext(AuthContext)

  return (
    <CardBox marginTop={3}>
      <ContentHead title='Courts' buttonText={isAdmin ? 'add court' : ''} />

      <CourtsContainer />
    </CardBox>
  )
}